export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail or username',
      invalidEmailOrUsername: 'Invalid e-mail or username',
      invalidPassword: 'Invalid password',
      logInToPlanka: 'Log in to Planka',
      noInternetConnection: 'No internet connection',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      projectManagement: 'Project management',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Unknown error, try again later',
      useSingleSignOn: 'Use single sign-on',
    },

    action: {
      logIn: 'Log in',
      logInWithSSO: 'Log in with SSO',
    },
  },
};
